import { PATHS } from '@tom-ui/utils'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import TerminalCrossing from './TerminalCrossing'

export const TerminalCrossingPage: FC = () => {
  const navigate = useNavigate()
  return <TerminalCrossing onClose={() => navigate(PATHS.arcade.url)} />
}
